import { Heading, Text } from 'ui-kit/typography'
import { DOCS_LINK } from 'routes/constants'
import { Actions, Link } from 'ui-kit/actions'
import clsx from 'clsx'
import classes from './IntegrationsCustomBlock.module.scss'

export const IntegrationsCustomBlock = () => {
  return (
    <div className={clsx(classes.wrapper)}>
      <Heading as={'h2'} center balance size={'xl'} className={classes.title}>
        Do not see the app you need?
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        You can either build one yourself using our{' '}
        <Link
          type='lineGradient'
          target='_blank'
          href={`${DOCS_LINK}/connector-builder`}
        >
          Connector Builder
        </Link>{' '}
        or request a custom connector from our team.
      </Text>
      <Actions className={classes.actions}>
        <Link
          href={'mailto:hello@integration.app?subject=Request a connector'}
          className={classes.button}
          asPageButton
          target={'_blank'}
          type='primary'
        >
          Request a Connector
        </Link>
        <Link
          href={`${DOCS_LINK}/connector-builder`}
          className={classes.button}
          asPageButton
          target={'_blank'}
          type='secondary'
        >
          Build Custom Connector
        </Link>
      </Actions>
    </div>
  )
}
